import { Component, OnInit, ViewChild } from '@angular/core'
import { catchError } from 'rxjs/operators'
import { empty, Observable } from 'rxjs'

import COUNTRIES from '../../assets/countries.json'
import OPT_IN_COUNTRY_CODES from '../../assets/opt-in-country-codes.json'
import { ErrorMessageComponent } from '../error-message/error-message.component'
import { SingleSignOnService } from '../single-sign-on.service'
import { SignupFormFactory, SignupFormType } from './signup-form-factory'

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  public signupForm: SignupFormType
  public countries: object[] = COUNTRIES
  public isSubmitDisabled: boolean = false

  @ViewChild(ErrorMessageComponent, { static: true })
  public errorMessageComponent: ErrorMessageComponent
  public testlineProvided: boolean = false

  public constructor(
    private _signupFormFactory: SignupFormFactory,
    private _singleSignOnService: SingleSignOnService
  ) {}

  public ngOnInit() {
    this.signupForm = this._signupFormFactory.create()
      
    this.testlineProvided = this._singleSignOnService.isTestlineProvided()
    if (!this.testlineProvided) {
      this.signupForm.addControl('testlineField', this._signupFormFactory.createNewField())
    }
  }

  public onCountryChange() {
    const countryCode = this.signupForm.value.country
    this.signupForm.controls.subscription.setValue(!OPT_IN_COUNTRY_CODES.includes(countryCode))
  }

  public onSubmit(data) {
    this.isSubmitDisabled = true
    const user = {
      'first-name': data.firstName,
      'last-name': data.lastName,
      'email': data.email,
      'password': data.password
    }

    const meta = {
      'zip-code': data.zipCode,
      'country': data.country,
      'allow-emails': data.subscription,
      'testline': this.testlineProvided 
        ? this._singleSignOnService.getTestLine() 
        : data.testlineField
    }
    
    this._singleSignOnService.signup(user, meta)
      .pipe(catchError(this._onSignupFailure()))
      .subscribe()
  }

  private _onSignupFailure() {
    return (response: any): Observable<any> => {
      this.isSubmitDisabled = false
      if (response.status === 422) {
        const msg = response.error.errors[0].detail
        this.errorMessageComponent.show(msg.charAt(0).toUpperCase() + msg.substr(1).toLowerCase() + '.')
      } else {
        this.errorMessageComponent.showDefault()
      }

      return empty()
    }
  }
}
